module.exports = __webpack_public_path__ + "static/media/route-parking-map.45f9e5da.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/client/shared/images/route-parking-map.png
// module id = 753
// module chunks = 0